"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ut$ = void 0;
var ddSdk_1 = require("../../../lib/ddSdk");
var apiName = 'biz.util.ut';
var utParamsObj2Str = function (params) {
    var finalParams = Object.assign({}, params);
    var tempValue = finalParams.value;
    var tempStr = [];
    if (tempValue && typeof tempValue === 'object') {
        for (var i in tempValue) {
            if (tempValue[i] !== undefined) {
                tempStr.push(i + '=' + tempValue[i]);
            }
        }
        tempValue = tempStr.join(',');
    }
    finalParams.value = tempValue || '';
    return finalParams;
};
ddSdk_1.ddSdk.setAPI(apiName, (_a = {},
    _a[ddSdk_1.ENV_ENUM.pc] = {
        vs: '3.5.0',
        paramsDeal: utParamsObj2Str,
    },
    _a[ddSdk_1.ENV_ENUM.ios] = {
        vs: '2.4.0',
        paramsDeal: function (params) {
            var finalParams = Object.assign({}, params);
            var tempValue = finalParams.value;
            var tempStr = [];
            if (tempValue && typeof tempValue === 'object') {
                tempValue = JSON.stringify(tempValue);
            }
            finalParams.value = tempValue;
            return finalParams;
        },
    },
    _a[ddSdk_1.ENV_ENUM.android] = {
        vs: '2.4.0',
        paramsDeal: utParamsObj2Str,
    },
    _a));
/**
 * 上报埋点
 * @apiName biz.util.ut
 * @supportVersion  pc: 3.0.0 ios: 2.4.0 android: 2.4.0
 */
function ut$(params) {
    return ddSdk_1.ddSdk.invokeAPI(apiName, params);
}
exports.ut$ = ut$;
exports.default = ut$;
